/* ==========================================================================
   EQ: Variant availability (2026-10-09)
   Pokazuje dostepnosc wariantow w obie strony:
   - rozmiar przekreslony, gdy nie ma go w wybranym kolorze
   - kolor przekreslony, gdy nie ma go w wybranym rozmiarze
   + linijka pomocnicza "Dostepne rozmiary w kolorze X: ..."
   2026-10-09 v2: trzeci stan "na zamowienie" (stan <= 0 + kontynuuj sprzedaz)
   - dane z snippets/eq-variant-stock.liquid, ikona zegara + podzial w linijce
   Motyw liczy dostepnosc tylko "w dol" (kolor wzgledem rozmiaru), wiec
   po kazdej jego aktualizacji przeliczamy atrybut [no-available] od nowa.
   ========================================================================== */
(function () {
  'use strict';

  var PL = (document.documentElement.lang || 'pl').toLowerCase().indexOf('pl') === 0;
  var RX_COLOR = /kolor|colou?r|farbe|couleur|colore/i;
  var RX_SIZE = /rozmiar|size|gr(ö|o)(ß|ss)e|taille|taglia/i;

  // Kody stanu z snippets/eq-variant-stock.liquid: o = od reki, z = na zamowienie, n = niedostepne
  function readStock(picker) {
    var pid = picker.getAttribute('data-product-id');
    if (!pid) return null;
    var el = document.querySelector('script[data-eq-variant-stock="' + pid + '"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function isOrderOnly(stock, v) {
    return !!stock && stock[v.id] === 'z';
  }

  function readVariants(picker) {
    var el = picker.querySelector('script[type="application/json"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Grupuje radio-inputy pickera wg opcji. Nazwa inputu konczy sie na "-N" (pozycja opcji).
  function readOptions(picker) {
    var groups = {};
    var order = [];
    picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var m = /^(.*)-(\d+)$/.exec(input.name || '');
      if (!m) return;
      var pos = parseInt(m[2], 10) - 1;
      if (!groups[pos]) { groups[pos] = { pos: pos, name: m[1], inputs: [] }; order.push(pos); }
      groups[pos].inputs.push(input);
    });
    return order.sort().map(function (p) { return groups[p]; });
  }

  function labelFor(input) {
    if (!input.id) return null;
    var sel = 'label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]';
    return document.querySelector(sel);
  }

  function update(picker) {
    var variants = readVariants(picker);
    var options = readOptions(picker);
    if (!variants || !variants.length || options.length < 2) {
      removeHint(picker);
      return;
    }

    var selected = options.map(function (o) {
      var c = o.inputs.filter(function (i) { return i.checked; })[0];
      return c ? c.value : null;
    });

    var available = variants.filter(function (v) { return v.available; });
    var stock = readStock(picker);

    picker.__eqWriting = true;
    options.forEach(function (opt) {
      opt.inputs.forEach(function (input) {
        var value = input.value;
        var matches = available.filter(function (v) {
          if (v.options[opt.pos] !== value) return false;
          for (var q = 0; q < options.length; q++) {
            var oq = options[q].pos;
            if (oq === opt.pos || selected[q] == null) continue;
            if (v.options[oq] !== selected[q]) return false;
          }
          return true;
        });
        var ok = matches.length > 0;
        // "Na zamowienie" tylko gdy zaden pasujacy wariant nie jest od reki
        var orderOnly = ok && !!stock && matches.every(function (v) { return isOrderOnly(stock, v); });
        var anyOk = available.some(function (v) { return v.options[opt.pos] === value; });
        var label = labelFor(input);
        if (!label) return;
        if (label.hasAttribute('no-available') !== !ok) label.toggleAttribute('no-available', !ok);
        if (label.classList.contains('eq-sold-out') !== !anyOk) label.classList.toggle('eq-sold-out', !anyOk);
        if (label.classList.contains('eq-backorder') !== orderOnly) label.classList.toggle('eq-backorder', orderOnly);
        label.setAttribute('aria-disabled', ok ? 'false' : 'true');
        var title = null;
        if (!ok) {
          title = PL ? (anyOk ? value + ' – niedostępne w tej kombinacji' : value + ' – wyprzedane') : (anyOk ? value + ' – not available in this combination' : value + ' – sold out');
        } else if (orderOnly) {
          title = PL ? value + ' – na zamówienie' : value + ' – made to order';
        }
        if (title) {
          if (label.getAttribute('title') !== title) label.setAttribute('title', title);
        } else if (label.getAttribute('title') && /niedost|wyprzed|zamówienie|not available|sold out|to order/i.test(label.getAttribute('title'))) {
          label.removeAttribute('title');
        }
      });
    });
    picker.__eqWriting = false;

    renderHint(picker, options, selected, available, stock);
  }

  function removeHint(picker) {
    var h = picker.querySelector('.eq-availability-hint');
    if (h) h.remove();
  }

  function renderHint(picker, options, selected, available, stock) {
    var colorIdx = -1, sizeIdx = -1;
    options.forEach(function (o, i) {
      if (colorIdx < 0 && RX_COLOR.test(o.name)) colorIdx = i;
      else if (sizeIdx < 0 && RX_SIZE.test(o.name)) sizeIdx = i;
    });
    if (colorIdx < 0 || sizeIdx < 0 || options.length !== 2) { removeHint(picker); return; }

    var color = selected[colorIdx];
    var hint = picker.querySelector('.eq-availability-hint');
    if (!color) { removeHint(picker); return; }

    var cPos = options[colorIdx].pos, sPos = options[sizeIdx].pos;
    var sizeOrder = options[sizeIdx].inputs.map(function (i) { return i.value; });
    var now = [], order = [];
    sizeOrder.forEach(function (s) {
      var m = available.filter(function (v) { return v.options[cPos] === color && v.options[sPos] === s; });
      if (!m.length) return;
      if (stock && m.every(function (v) { return isOrderOnly(stock, v); })) order.push(s);
      else now.push(s);
    });
    var sizes = now.concat(order);

    function chips(list, cls) {
      return list.map(function (s) { return '<span class="eq-availability-hint__size' + (cls ? ' ' + cls : '') + '">' + esc(s) + '</span>'; }).join('');
    }

    var html;
    if (sizes.length && !order.length) {
      html = (PL ? 'Dostępne rozmiary w kolorze ' : 'Available sizes in ') +
        '<strong>' + esc(color) + '</strong>: ' + chips(now);
    } else if (sizes.length) {
      html = (PL ? 'Kolor ' : 'Colour ') + '<strong>' + esc(color) + '</strong>:';
      if (now.length) {
        html += '<span class="eq-availability-hint__row">' + (PL ? 'Od ręki: ' : 'In stock: ') + chips(now) + '</span>';
      }
      html += '<span class="eq-availability-hint__row">' +
        '<span class="eq-backorder-icon" aria-hidden="true"></span>' +
        (PL ? 'Na zamówienie: ' : 'Made to order: ') + chips(order, 'eq-availability-hint__size--order') + '</span>';
    } else {
      html = PL
        ? 'Kolor <strong>' + esc(color) + '</strong> jest obecnie niedostępny w żadnym rozmiarze.'
        : '<strong>' + esc(color) + '</strong> is currently unavailable in every size.';
    }

    if (!hint) {
      hint = document.createElement('div');
      hint.className = 'eq-availability-hint';
      hint.setAttribute('aria-live', 'polite');
      // .product-variant-picker__form jest ukryty (display:none) – widoczne przyciski sa bezposrednio w pickerze
      picker.appendChild(hint);
    }
    hint.classList.toggle('eq-availability-hint--empty', !sizes.length);
    if (hint.innerHTML !== html) hint.innerHTML = html;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  // Przeliczenie po kazdej zmianie (motyw ustawia swoje [no-available] synchronicznie
  // lub po fetchu sekcji – dlatego requestAnimationFrame + obserwator).
  var queued = new Set();
  function schedule(picker) {
    if (!picker || queued.has(picker)) return;
    queued.add(picker);
    requestAnimationFrame(function () {
      queued.delete(picker);
      if (picker.isConnected) update(picker);
    });
  }

  function attach(picker) {
    if (picker.__eqAttached) { schedule(picker); return; }
    picker.__eqAttached = true;
    picker.addEventListener('change', function () { schedule(picker); });
    new MutationObserver(function () {
      if (!picker.__eqWriting) schedule(picker);
    }).observe(picker, { subtree: true, childList: true, attributes: true, attributeFilter: ['no-available', 'checked', 'class'] });
    schedule(picker);
  }

  function scan(root) {
    (root || document).querySelectorAll('variant-picker').forEach(attach);
  }

  function init() {
    scan();
    // Quick view / ponowne renderowanie sekcji wstawia nowe pickery
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'VARIANT-PICKER') attach(n);
          else if (n.querySelector && n.querySelector('variant-picker')) scan(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
